import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const Categroy = (props: any) => {
  let history = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const [cateBtnStyle, setCateBtnStyle] = useState({
    color: "#6C6BB2",
    marginRight: "150px",
    paddingLeft: "30px",
    fontFamily: "SCDream7",
  });

  const [cateBtnImgStyle, setCateBtnImgStyle] = useState({
    height: "45px",
    width: "auto",
    marginTop: "-10px",
    transform: "scale(1,1)",
    transition: "100ms ease-in-out",
    cursor: "pointer",
  });

  const onClickCategory = () => {
    if (open) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  const btnCateMouseOver = () => {
    if (window.innerWidth < 450) {
      setCateBtnStyle({
        color: "#6C6BB2",
        marginRight: "15px",
        paddingLeft: "5px",
        fontFamily: "SCDream7",
      });

      setCateBtnImgStyle({
        height: "25px",
        width: "auto",
        marginTop: "-4px",
        transform: "scale(1.2,1.2)",
        transition: "100ms ease-in-out",
        cursor: "pointer",
      });
    } else if (window.innerWidth < 900) {
      setCateBtnStyle({
        color: "#6C6BB2",
        marginRight: "50px",
        paddingLeft: "15px",
        fontFamily: "SCDream7",
      });

      setCateBtnImgStyle({
        height: "35px",
        width: "auto",
        marginTop: "-5px",
        transform: "scale(1.2,1.2)",
        transition: "100ms ease-in-out",
        cursor: "pointer",
      });
    } else {
      setCateBtnStyle({
        color: "#6C6BB2",
        marginRight: "150px",
        paddingLeft: "30px",
        fontFamily: "SCDream7",
      });

      setCateBtnImgStyle({
        height: "45px",
        width: "auto",
        marginTop: "-10px",
        transform: "scale(1.2,1.2)",
        transition: "100ms ease-in-out",
        cursor: "pointer",
      });
    }
  };

  const btnCateMouseLeave = () => {
    if (window.innerWidth < 450) {
      setCateBtnStyle({
        color: "#6C6BB2",
        marginRight: "15px",
        paddingLeft: "5px",
        fontFamily: "SCDream7",
      });

      setCateBtnImgStyle({
        height: "25px",
        width: "auto",
        marginTop: "-4px",
        transform: "scale(1,1)",
        transition: "100ms ease-in-out",
        cursor: "pointer",
      });
    } else if (window.innerWidth < 900) {
      setCateBtnStyle({
        color: "#6C6BB2",
        marginRight: "50px",
        paddingLeft: "15px",
        fontFamily: "SCDream7",
      });

      setCateBtnImgStyle({
        height: "35px",
        width: "auto",
        marginTop: "-5px",
        transform: "scale(1,1)",
        transition: "100ms ease-in-out",
        cursor: "pointer",
      });
    } else {
      setCateBtnStyle({
        color: "#6C6BB2",
        marginRight: "150px",
        paddingLeft: "30px",
        fontFamily: "SCDream7",
      });

      setCateBtnImgStyle({
        height: "45px",
        width: "auto",
        marginTop: "-10px",
        transform: "scale(1.0,1.0)",
        transition: "100ms ease-in-out",
        cursor: "pointer",
      });
    }
  };

  const handleResize = () => {
    if (window.innerWidth < 450) {
      setCateBtnStyle({
        color: "#6C6BB2",
        marginRight: "15px",
        paddingLeft: "5px",
        fontFamily: "SCDream7",
      });

      setCateBtnImgStyle({
        height: "25px",
        width: "auto",
        marginTop: "-4px",
        transform: "scale(1,1)",
        transition: "100ms ease-in-out",
        cursor: "pointer",
      });
    } else if (window.innerWidth < 900) {
      setCateBtnStyle({
        color: "#6C6BB2",
        marginRight: "50px",
        paddingLeft: "15px",
        fontFamily: "SCDream7",
      });

      setCateBtnImgStyle({
        height: "35px",
        width: "auto",
        marginTop: "-5px",
        transform: "scale(1,1)",
        transition: "100ms ease-in-out",
        cursor: "pointer",
      });
    } else {
      setCateBtnStyle({
        color: "#6C6BB2",
        marginRight: "150px",
        paddingLeft: "30px",
        fontFamily: "SCDream7",
      });

      setCateBtnImgStyle({
        height: "45px",
        width: "auto",
        marginTop: "-10px",
        transform: "scale(1,1)",
        transition: "100ms ease-in-out",
        cursor: "pointer",
      });
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    setLoading(true);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    // console.log("loading::", loading);
  }, [loading]);

  const selectedCate = (cateCode: any) => {
    history("/goods?cateCd=" + cateCode);
    if (location.pathname === "/goods") {
      props.setContents("");
      props.setKind(cateCode);
    }
    setOpen(false);
  };

  return (
    <div>
      {loading && (
        <div>
          <hr
            style={{
              //   width: "97vw",
              border: "solid 1px #eaeaea",
            }}
          ></hr>
          <div className="div-category-form">
            <img
              style={cateBtnImgStyle}
              className="btn-category-img"
              src={"/svg/menu.svg"}
              alt="menuSvg"
              onClick={() => onClickCategory()}
              onMouseOver={() => btnCateMouseOver()}
              onMouseLeave={() => btnCateMouseLeave()}
            />
            <span
              style={cateBtnStyle}
              onMouseOver={() => btnCateMouseOver()}
              onMouseLeave={() => btnCateMouseLeave()}
              onClick={() => onClickCategory()}
            >
              카테고리
            </span>
            <span
              onClick={() => {
                history("/goods");
                if (location.pathname === "/goods") {
                  // window.location.reload();
                  props.setKind("");
                  props.setContents("");
                }
                setOpen(false);
              }}
            >
              전체
            </span>
            <span onClick={() => selectedCate("BEST")}>BEST</span>
            <span onClick={() => selectedCate("T001")}>병•의원 전문</span>
            <span onClick={() => selectedCate("T002")}>유산균</span>
            <span onClick={() => selectedCate("T003")}>선물관</span>
          </div>
          <hr
            style={{
              //   width: "97vw",
              border: "solid 1px #eaeaea",
            }}
          ></hr>
          <div
            className={
              open === false
                ? "div-category-board close"
                : "div-category-board open"
            }
          >
            <div className="display-divide-3" style={{ padding: "0px" }}>
              <div className="div-category-board-empty">
                <div className="div-category-board-title"></div>
                <ul className="list"></ul>
              </div>
              <div style={{ flex: "1" }}>
                <div className="div-category-board-title">
                  <span>종류별</span>
                </div>
                <ul className="list">
                  <li>
                    <span onClick={() => selectedCate("K001")}>
                      건강(기능)식품
                    </span>
                  </li>
                  <li>
                    <span onClick={() => selectedCate("K002")}>의료기기</span>
                  </li>
                  <li>
                    <span onClick={() => selectedCate("K003")}>전자기기</span>
                  </li>
                </ul>
              </div>
              <div style={{ flex: "1" }}>
                <div className="div-category-board-title">
                  <span>기능별</span>
                </div>
                <ul className="list">
                  <li>
                    <span onClick={() => selectedCate("F001")}>다이어트</span>
                  </li>
                  <li>
                    <span onClick={() => selectedCate("F002")}>뼈/관절</span>
                  </li>
                  <li>
                    <span onClick={() => selectedCate("F003")}>장 건강</span>
                  </li>
                  <li>
                    <span onClick={() => selectedCate("F004")}>
                      눈/위/간 건강
                    </span>
                  </li>
                  <li>
                    <span onClick={() => selectedCate("F005")}>혈관 건강</span>
                  </li>
                  <li>
                    <span onClick={() => selectedCate("F006")}>
                      피부/황산화
                    </span>
                  </li>
                  <li>
                    <span onClick={() => selectedCate("F007")}>면역 건강</span>
                  </li>
                  <li>
                    <span onClick={() => selectedCate("F008")}>수면 건강</span>
                  </li>
                  <li>
                    <span onClick={() => selectedCate("F009")}>임신/출산</span>
                  </li>
                  <li>
                    <span onClick={() => selectedCate("F010")}>갱년기</span>
                  </li>
                  <li>
                    <span onClick={() => selectedCate("F011")}>
                      활력/전립선
                    </span>
                  </li>
                  <li>
                    <span onClick={() => selectedCate("F012")}>뇌/기억력</span>
                  </li>
                  <li>
                    <span onClick={() => selectedCate("F013")}>
                      베이비/키즈
                    </span>
                  </li>
                </ul>
              </div>
              <div style={{ flex: "1" }}>
                <div className="div-category-board-title">
                  <span>특별관</span>
                </div>
                <ul className="list">
                  <li>
                    <span onClick={() => selectedCate("S001")}>피스팜</span>
                  </li>
                  <li>
                    <span onClick={() => selectedCate("S002")}>
                      비엠지 바이오
                    </span>
                  </li>
                  <li>
                    <span onClick={() => selectedCate("S003")}>휴럼</span>
                  </li>
                  <li>
                    <span onClick={() => selectedCate("S004")}>레드앤블루</span>
                  </li>
                </ul>
              </div>

              <div className="div-category-board-empty">
                <div className="div-category-board-title"></div>
                <ul className="list"></ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Categroy;
